module.exports = "https://web-assets.ifttt.com/packs/media/layout/ios_download-706f7700.svg";